import script from "./WelcomeMap.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeMap.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeMap.vue?vue&type=style&index=0&id=c89a665c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c89a665c"]])

export default __exports__